export const QueryStringTypes = {
  PageSize: 'pagesize',
  PageNumber: 'pagenumber',
  Sort: 'sort',
};

export enum QueryStringTypesEnum {
  Transaction_key = 'key-transactions',
  Organization_key = 'key-organizations',
  PrivateNumbers_key = 'key-privateNumbers',
  Documents_key = 'key-documents',
  Receivers_key = 'key-receivers',
  Update_key = 'key-update',
  Details_key = 'key-details',
  ResendDetails_key = 'key-resendDetails',
  ResendByDeliveryStatus_key = 'key-resendByDeliveryStatus',
  CreditTransfer_key = 'key-creditTransfer',
  GroupPriceDetail_key = 'key-groupPriceDetail',
  Resellers_key = 'key-resellers',
  TransferPrivateNumber_key = 'key-transferPrivateNumber',
  Clone_key = 'key-clone',
  RequestDetails_key = 'key-requestDetails',
  Report_key = 'key-report',
  Club_key = 'key-club',
  Rules_key = 'key-rules',
  UsersSeen_key = 'key-usersSeen',
  SendInformation_key = 'key-sendInformation',
  ScheduledMessage_key = 'key-scheduledMessage',
  Stats_key = 'key-stats',
  Campaign_key = 'key-campaign',
  OrganizationsBlackListExceptions_key = 'key-organizationsBlackListExceptionsComponent',
  SmartId_key = 'key-smartId',
  IsPeriodic_key = 'key-isPeriodic',
  ScheduledMessageTitle_key = 'key-scheduledMessageTitle',
}

export interface GetKeyTypesDto {
  keyName?: string;
  keyType?: string;
}
